import { render, staticRenderFns } from "./Heador.vue?vue&type=template&id=7f6cc0dd&"
import script from "./Heador.vue?vue&type=script&lang=js&"
export * from "./Heador.vue?vue&type=script&lang=js&"
import style0 from "./Heador.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports